import store from 'surface/xstore'
const currentHash = window.location.hash

const hashes = {
  settings: '#settings',
  share: '#share',
  remake: '#remake',
}

const resetHash = () => history.replaceState('', document.title, window.location.pathname)

// Change the hash as the state is changing. This allows the use of back button in
// mobile browsers when full screen panels show up.
// We use history.pushstate because we don't want to trigger onhashchange.
// This guy needs to be super careful to not add random items in history. Which is
// why it makes sure that the current hash already doesn't match the hash we want
// to set.
// ww.store.subscribe ->
//   state = ww.store.getState()
//   if state.settingsPanel and currentHash isnt hashes.settings
//     currentHash = hashes.settings
//     history.pushState "", document.title, currentHash
//   else if state.sharePanel and currentHash isnt hashes.share
//     currentHash = hashes.share
//     history.pushState "", document.title, currentHash
//   else if (currentHash is hashes.settings or currentHash is hashes.share) and !state.sharePanel and !state.settingsPanel
//     history.pushState "", document.title, window.location.pathname
//     currentHash = ""

// Purely handles back and forward buttons.
// window.onhashchange = ->
//   oldHash = currentHash
//   currentHash = window.location.hash
//   currentHashIsBlank = (currentHash is "" or currentHash is "#")
//   if oldHash is hashes.settings and currentHash isnt hashes.settings
//     ww.store.dispatch type: "SETTINGS_HIDE"
//   else if oldHash is hashes.share and currentHash isnt hashes.share
//     ww.store.dispatch type: "SHARE_HIDE"
//   else if currentHash is hashes.settings
//     ww.store.dispatch type: "SETTINGS_SHOW"
//   else if currentHash is hashes.share
//     ww.store.dispatch type: "SHARE_SHOW"

// Handle the hash of a fresh page.
// If it isn't blank, dispatch the right event to show the appropriate panel.

const watchHash = () => {
  if (currentHash === hashes.settings) {
    store.dispatch('settings/showSettingsPanel')
    resetHash()
  } else if (currentHash === hashes.share) {
    store.dispatch('share/showSharePanel')
    resetHash()
  } else if (currentHash === hashes.remake) {
    store.dispatch('showRemakePanel')
    resetHash()
  }
}

export { watchHash }
